import { render, staticRenderFns } from "./Remark.vue?vue&type=template&id=ac33ff88&scoped=true&"
import script from "./Remark.vue?vue&type=script&lang=js&"
export * from "./Remark.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac33ff88",
  null
  
)

export default component.exports